const firebaseConfig = {
    apiKey: "AIzaSyAHpJf0DwRtsbd5pOISwDctj-dzh-z5WxI",
    authDomain: "book-shop-6fa77.firebaseapp.com",
    projectId: "book-shop-6fa77",
    storageBucket: "book-shop-6fa77.appspot.com",
    messagingSenderId: "876919877362",
    appId: "1:876919877362:web:6b3c0447cae5caa56bea6b"
  };
  export default firebaseConfig